import { faAddressCard as addressCard } from '@fortawesome/pro-light-svg-icons/faAddressCard';
import { faAngleDown as angleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAnglesLeft as anglesLeft } from '@fortawesome/pro-light-svg-icons/faAnglesLeft';
import { faAnglesRight as anglesRight } from '@fortawesome/pro-light-svg-icons/faAnglesRight';
import { faArrowUpRightFromSquare as arrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { faArrowsRotate as arrowsRotate } from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import { faAt as at } from '@fortawesome/pro-light-svg-icons/faAt';
import { faBadgePercent as badgePercent } from '@fortawesome/pro-light-svg-icons/faBadgePercent';
import { faBell as bell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faBlog as blog } from '@fortawesome/pro-light-svg-icons/faBlog';
import { faBookOpen as bookOpen } from '@fortawesome/pro-light-svg-icons/faBookOpen';
import { faBookUser as bookUser } from '@fortawesome/pro-light-svg-icons/faBookUser';
import { faBoxOpen as boxOpen } from '@fortawesome/pro-light-svg-icons/faBoxOpen';
import { faBriefcaseBlank as briefcaseBlank } from '@fortawesome/pro-light-svg-icons/faBriefcaseBlank';
import { faBullhorn as bullhorn } from '@fortawesome/pro-light-svg-icons/faBullhorn';
import { faCalendarRange as calendarRange } from '@fortawesome/pro-light-svg-icons/faCalendarRange';
import { faCalendarStar as calendarStar } from '@fortawesome/pro-light-svg-icons/faCalendarStar';
import { faCircleCheck as circleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import { faCircleExclamation as circleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { faClock as clock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faClover as clover } from '@fortawesome/pro-light-svg-icons/faClover';
import { faCog as cog } from '@fortawesome/pro-light-svg-icons/faCog';
import { faCoins as coins } from '@fortawesome/pro-light-svg-icons/faCoins';
import { faCopy as copy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faDisplay as display } from '@fortawesome/pro-light-svg-icons/faDisplay';
import { faDollarSign as dollarSign } from '@fortawesome/pro-light-svg-icons/faDollarSign';
import { faDownload as download } from '@fortawesome/pro-light-svg-icons/faDownload';
import { faEarthAfrica as earthAfrica } from '@fortawesome/pro-light-svg-icons/faEarthAfrica';
import { faEarthAmericas as earthAmericas } from '@fortawesome/pro-light-svg-icons/faEarthAmericas';
import { faEarthAsia as earthAsia } from '@fortawesome/pro-light-svg-icons/faEarthAsia';
import { faEarthEurope as earthEurope } from '@fortawesome/pro-light-svg-icons/faEarthEurope';
import { faEarthOceania as earthOceania } from '@fortawesome/pro-light-svg-icons/faEarthOceania';
import { faEnvelope as envelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faEuroSign as euroSign } from '@fortawesome/pro-light-svg-icons/faEuroSign';
import { faExpand as expand } from '@fortawesome/pro-light-svg-icons/faExpand';
import { faFilter as filter } from '@fortawesome/pro-light-svg-icons/faFilter';
import { faFilterSlash as filterSlash } from '@fortawesome/pro-light-svg-icons/faFilterSlash';
import { faFireFlameCurved as fireFlameCurved } from '@fortawesome/pro-light-svg-icons/faFireFlameCurved';
import { faGear as gear } from '@fortawesome/pro-light-svg-icons/faGear';
import { faGenderless as genderless } from '@fortawesome/pro-light-svg-icons/faGenderless';
import { faGlobe as globe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { faHandshakeSimple as handshakeSimple } from '@fortawesome/pro-light-svg-icons/faHandshakeSimple';
import { faHeart as heart } from '@fortawesome/pro-light-svg-icons/faHeart';
import { faHistory as history } from '@fortawesome/pro-light-svg-icons/faHistory';
import { faIdBadge as idBadge } from '@fortawesome/pro-light-svg-icons/faIdBadge';
import { faImage as image } from '@fortawesome/pro-light-svg-icons/faImage';
import { faImages as images } from '@fortawesome/pro-light-svg-icons/faImages';
import { faInboxIn as inboxIn } from '@fortawesome/pro-light-svg-icons/faInboxIn';
import { faInboxOut as inboxOut } from '@fortawesome/pro-light-svg-icons/faInboxOut';
import { faLanguage as language } from '@fortawesome/pro-light-svg-icons/faLanguage';
import { faLink as link } from '@fortawesome/pro-light-svg-icons/faLink';
import { faListOl as listOl } from '@fortawesome/pro-light-svg-icons/faListOl';
import { faLock as lock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faMagnifyingGlass as magnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faMars as mars } from '@fortawesome/pro-light-svg-icons/faMars';
import { faMarsAndVenus as marsAndVenus } from '@fortawesome/pro-light-svg-icons/faMarsAndVenus';
import { faMedal as medal } from '@fortawesome/pro-light-svg-icons/faMedal';
import { faMemo as memo } from '@fortawesome/pro-light-svg-icons/faMemo';
import { faMercury as mercury } from '@fortawesome/pro-light-svg-icons/faMercury';
import { faMessage as message } from '@fortawesome/pro-light-svg-icons/faMessage';
import { faMessageImage as messageImage } from '@fortawesome/pro-light-svg-icons/faMessageImage';
import { faMessageLines as messageLines } from '@fortawesome/pro-light-svg-icons/faMessageLines';
import { faMessagePen as messagePen } from '@fortawesome/pro-light-svg-icons/faMessagePen';
import { faMessageSlash as messageSlash } from '@fortawesome/pro-light-svg-icons/faMessageSlash';
import { faMessages as messages } from '@fortawesome/pro-light-svg-icons/faMessages';
import { faMessagesDollar as messagesDollar } from '@fortawesome/pro-light-svg-icons/faMessagesDollar';
import { faMinus as minus } from '@fortawesome/pro-light-svg-icons/faMinus';
import { faMobile as mobile } from '@fortawesome/pro-light-svg-icons/faMobile';
import { faMoonStars as moonStars } from '@fortawesome/pro-light-svg-icons/faMoonStars';
import { faNote as note } from '@fortawesome/pro-light-svg-icons/faNote';
import { faPeopleArrows as peopleArrows } from '@fortawesome/pro-light-svg-icons/faPeopleArrows';
import { faPeopleGroup as peopleGroup } from '@fortawesome/pro-light-svg-icons/faPeopleGroup';
import { faPhone as phone } from '@fortawesome/pro-light-svg-icons/faPhone';
import { faPlus as plus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faPoundSign as poundSign } from '@fortawesome/pro-light-svg-icons/faPoundSign';
import { faPuzzle as puzzle } from '@fortawesome/pro-light-svg-icons/faPuzzle';
import { faReceipt as receipt } from '@fortawesome/pro-light-svg-icons/faReceipt';
import { faRectangleAd as rectangleAd } from '@fortawesome/pro-light-svg-icons/faRectangleAd';
import { faRightFromBracket as rightFromBracket } from '@fortawesome/pro-light-svg-icons/faRightFromBracket';
import { faRightToBracket as rightToBracket } from '@fortawesome/pro-light-svg-icons/faRightToBracket';
import { faRotateLeft as rotateLeft } from '@fortawesome/pro-light-svg-icons/faRotateLeft';
import { faShareAlt as shareAlt } from '@fortawesome/pro-light-svg-icons/faShareAlt';
import { faShareNodes as shareNodes } from '@fortawesome/pro-light-svg-icons/faShareNodes';
import { faShield as shield } from '@fortawesome/pro-light-svg-icons/faShield';
import { faShieldCheck as shieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faSquare as square } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faSquareCheck as squareCheck } from '@fortawesome/pro-light-svg-icons/faSquareCheck';
import { faSunBright as sunBright } from '@fortawesome/pro-light-svg-icons/faSunBright';
import { faTimer as timer } from '@fortawesome/pro-light-svg-icons/faTimer';
import { faTimes as times } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faTransgender as transgender } from '@fortawesome/pro-light-svg-icons/faTransgender';
import { faTrash as trash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faUserFriends as userFriends } from '@fortawesome/pro-light-svg-icons/faUserFriends';
import { faUserGroup as userGroup } from '@fortawesome/pro-light-svg-icons/faUserGroup';
import { faUserSecret as userSecret } from '@fortawesome/pro-light-svg-icons/faUserSecret';
import { faUserSlash as userSlash } from '@fortawesome/pro-light-svg-icons/faUserSlash';
import { faVenus as venus } from '@fortawesome/pro-light-svg-icons/faVenus';
import { faXmark as xmark } from '@fortawesome/pro-light-svg-icons/faXmark';

const icons = {
  addressCard,
  angleDown,
  anglesLeft,
  anglesRight,
  arrowUpRightFromSquare,
  arrowsRotate,
  at,
  badgePercent,
  bell,
  blog,
  bookOpen,
  bookUser,
  boxOpen,
  briefcaseBlank,
  bullhorn,
  calendarRange,
  calendarStar,
  circleCheck,
  circleExclamation,
  clock,
  clover,
  cog,
  coins,
  copy,
  display,
  dollarSign,
  download,
  earthAfrica,
  earthAmericas,
  earthAsia,
  earthEurope,
  earthOceania,
  envelope,
  euroSign,
  expand,
  filter,
  filterSlash,
  fireFlameCurved,
  gear,
  genderless,
  globe,
  handshakeSimple,
  heart,
  history,
  idBadge,
  image,
  images,
  inboxIn,
  inboxOut,
  language,
  link,
  listOl,
  lock,
  magnifyingGlass,
  mars,
  marsAndVenus,
  medal,
  memo,
  mercury,
  message,
  messageImage,
  messageLines,
  messagePen,
  messageSlash,
  messages,
  messagesDollar,
  minus,
  mobile,
  moonStars,
  note,
  peopleArrows,
  peopleGroup,
  phone,
  plus,
  poundSign,
  puzzle,
  receipt,
  rectangleAd,
  rightFromBracket,
  rightToBracket,
  rotateLeft,
  shareAlt,
  shareNodes,
  shield,
  shieldCheck,
  square,
  squareCheck,
  sunBright,
  timer,
  times,
  transgender,
  trash,
  userFriends,
  userGroup,
  userSecret,
  userSlash,
  venus,
  xmark,
};

export default icons;
